<template>
  <div class="replacementmonthlystatistics__report__view">
    <div class="reports__subheader">

      <year-month-panel @year="(value) => year = value"
                        @month="(value) => month = value"
                        :offsetMonth="12">
      </year-month-panel>

      <group-panel @groupId="value => groupId = value">
      </group-panel>

      <region-panel @region="value => region = value" v-if="isAdmin">
      </region-panel>

      <submit-panel @submit="performLookup">
      </submit-panel>

      <print-panel @submit="print">
      </print-panel>
    </div>

    <b-table :data="groupedByDay" 
             :loading="loading"
             :row-class="(row, index) => row.isSunday && !row.isHoliday ? 'column-sunday' : row.isHoliday ? 'column-holiday' : ''"
             v-if="groupedByDay && groupedByDay.length > 0">
        <b-table-column v-for="(column, index) in columns" 
            :key="index"        
            :label="column.label"
            v-slot="props">
          <div v-if="index > 0" :class="[colorMap(props.row[column.field])]">{{ translateAllocation(props.row[column.field]) }}</div>
          <div v-if="index === 0">
            {{ props.row.day }} <span v-if="props.row.week"> (uge: {{ props.row.week }})</span> <span v-if="props.row.isHoliday"> - {{ props.row.holidayName }}</span>
          </div>
        </b-table-column>
    </b-table>
    <b-loading :is-full-page="isFullPage" :active.sync="saving" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import APISTATE from '@/enums/APISTATE';
import SubmitPanel from '@/components/report/SubmitPanel.vue';
import YearMonthPanel from '@/components/report/YearMonthPanel.vue';
import GroupPanel from '@/components/report/GroupPanel.vue';
import PrintPanel from '@/components/report/PrintPanel.vue';
import RegionPanel from '@/components/report/RegionPanel.vue';

export default {
  name: 'monthlygroup-report-view',
  components: { SubmitPanel, YearMonthPanel, GroupPanel,PrintPanel,RegionPanel },
  props: {
    employeeNumber: {
      type: Number,
      required: undefined,
    }
  },
  data: () => ({
    year: undefined,
    month: undefined,
    employeeId: undefined,
    groupId: undefined,
    region: undefined,
    saving: false,
    isFullPage: true,
    groupedByDay: [],
    columns: []
  }),
  async mounted() {
    await this.$store.dispatch('metadata/initialize');

    this.year = 2022;
    this.month = 0;

    if(this.isAdmin === false) {
      this.employeeId = this.currentUser.id;
      this.groupId = this.currentUser.groupId;
    }
  },
  methods: {
    ...mapActions('reportStore', ['getMonthGroupReport']),
    async performLookup() {
      const dto = {
        year: this.year,
        month: this.month + 1,
        forUser: this.employeeId,
        forGroup: this.groupId,
        forRegion: this.region
      };

      this.groupedByDay = [];
      this.columns = [];
      
      await this.getMonthGroupReport(dto);
      var compare = (a, b) => {
        let noa = a.orderNumber;
        let nob = b.orderNumber;

        if(noa < nob){
          return -1;
        }

        if(noa > nob){           
          return 1;
        }

        return 0;
      }; 

      let data = [];
      let colums = [{
        field: "day",
        label: "Dag",
        width: "40",
        numeric: true
      }];

      const sorted = this.monthReportGroup.sort(compare);
      for(let item of sorted) {
          const key = item.day + " - " + item.dayName;
          let day = data.find(o => o.day === key);
          if(day){
            day[item.employeeId] = item;
          }else{
            day = {
              day: key,
              holidayName: item.holidayName,
              isHoliday: item.isHoliday,
              isSunday: item.isSunday,
              week: item.week
            };
            day[item.employeeId] = item;

            data.push(day)
          }

          if(!colums.find(o => o.label === item.name)){
            colums.push({
              field: item.employeeId,
              label: item.name
            });
          }
      }

      this.groupedByDay = data;
      this.columns = colums;
    },
    translateAllocation(arg) {
      if(!arg){
        return "-";
      }
      const key = arg.allocationType;
      const keys = key.split(" / ");

      if(this.allocationTypesReport) {
        let result = undefined;
        for(let item of keys) {
          if(item === "WORK") {
            if(result) {
                result = result + " / " + arg.circleName.toUpperCase();
              } else {
                result = arg.circleName.toUpperCase();
              }
          } else {
            let obj = this.allocationTypesReport.find(o => o.key === item);
            if(obj) {
              if(result) {
                result = result + " / " + obj.shortName.toUpperCase();
              } else {
                result = obj.shortName.toUpperCase();
              }
            }
          }
        }
        return result;
      }

      return key;
    },
    colorMap(arg){
      const colors = ['orange','green','aqua','blue','purple','magenta','red','gray','black'];

      if(!arg){
        return 'white';
      }

      if(arg.allocationType === "HOLIDAY" || arg.allocationType === "VACATION"){
          return "black";
      }

      if(arg.allocationType === "OFFDAY") {
        return "yellow";
      }

      if(arg && arg.colorCode && colors.indexOf(arg.colorCode) > -1) {
        return arg.colorCode;
      }

      return 'white';
    },
    tdColorMap(item, row) {
      return 'white';
    },
    print(){
      window.print();
    }
  },
  computed: {
    ...mapGetters('reportStore', ['monthReportGroupApiState', 'monthReportGroup']),
    ...mapGetters('metadata', ['allocationTypes', 'allocationTypesReport']),
    ...mapGetters(["currentUser", "isAdmin"]),
    loading() {
      return this.monthReportGroupApiState === APISTATE.LOADING;
    }
  }
}
</script>

<style lang="scss" scoped>
div.blue {
  background: rgba(0, 70, 150, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.orange {
  background-color: rgba(250, 100, 0, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.purple {
  background:rgba(120, 50, 140, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.magenta {
  background-color: rgba(210, 40, 100, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.red {
  background-color: rgba(210, 10, 10, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.gray  {
  background-color: rgba(136, 136, 136, 0.8);
  color: black;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.black {
  background-color: rgba(34, 34, 34, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.aqua {
  background-color: rgba(60, 160, 200, 0.8);
  color: black;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}

div.green {
  background-color: rgba(30, 140, 10, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}

div.yellow {
  background-color: rgba(246, 255, 0, 0.8);
  color: black;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
.b-table {
  font-size: 12px;
} 
@media print { 
  
  .b-table {
    line-height: 0.7 !important;
    font-size: 11px;
  } 
  .reports__panel--print,.reports__panel--submit {
    display: none;
  }
}
</style>